import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PinItTrackWebLoginPageComponent } from '@pit/frontend-ui-core';
import { PinItTrackFrontendWebMainPageComponent } from '../pages/pin.it.track.frontend.web.main.page/pin.it.track.frontend.web.main.page.component';
import { PinItTrackWebPasswordPageComponent } from '@pit/frontend-ui-core';

const routes: Routes = [
  {
    path: '',
    component: PinItTrackFrontendWebMainPageComponent,
    children: [
      {
        path: 'shipment',
        data: { title: 'Sendungen' },
        loadChildren: () => import('@pit/frontend-shipment').then(m => m.PinItTrackFrontendShipmentModule)
      },
      /*{
          path: 'postman',
          loadChildren: () => import('@pit/frontend-postman').then(m => m.PinItTrackFrontendPostmanModule)
      },*/
      {
        path: 'version',
        data: { title: 'Versionen' },
        loadChildren: () => import('@pit/frontend-version').then(m => m.PinItTrackFrontendVersionModule)
      },
      {
        path: 'depot',
        data: { title: 'Depots' },
        loadChildren: () => import('@pit/frontend-depot').then(m => m.PinItTrackFrontendDepotModule)
      },
      {
        path: 'device',
        data: { title: 'Geräte' },
        loadChildren: () => import('@pit/frontend-device').then(m => m.PinItTrackFrontendDeviceModule)
      },
      {
        path: 'resource',
        data: { title: 'Zustelltechnik' },
        loadChildren: () => import('@pit/frontend-resource').then(m => m.PinItTrackFrontendResourceModule)
      },
      {
        path: 'location',
        data: { title: 'Koordinaten' },
        loadChildren: () => import('@pit/frontend-location').then(m => m.PinItTrackFrontendLocationModule)
      },
      {
        path: 'tour',
        data: { title: 'Touren' },
        loadChildren: () => import('@pit/frontend-tour').then(m => m.PinItTrackFrontendTourModule)
      },
      {
        path: 'setting',
        data: { title: 'Einstellungen' },
        loadChildren: () => import('@pit/frontend-setting').then(m => m.PinItTrackFrontendSettingsModule)
      },
      {
        path: 'user',
        data: { title: 'Benutzer' },
        loadChildren: () => import('@pit/frontend-user').then(m => m.PinItTrackFrontendUserModule)
      },
      {
        path: 'home',
        data: { title: 'Start' },
        loadChildren: () => import('@pit/frontend-dashboard').then(m => m.PinItTrackFrontendDashboardModule)
      }
    ]
  },
  {
    path: 'auth/login',
    component: PinItTrackWebLoginPageComponent
  },
  {
    path: 'auth/password/reset',
    component: PinItTrackWebPasswordPageComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'disabled',
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor() { }

}
